import update from "immutability-helper";
import { ActionType, getType } from "typesafe-actions";
import * as bookOfTheMonthActions from "./book-of-the-month-actions";
import { IProduct } from "~/types/product";
import { IProductDetailsProps } from "~/components/product-details/product-details";
export type BookOfTheMonthAction = ActionType<typeof bookOfTheMonthActions>;

export interface IBookOfTheMonthState {
    isSkipBookOfTheMonthPending: boolean;
    bookOfTheMonthStatusLabel?: IProduct["bookOfTheMonthStatusLabel"];
    isSkipBookOfTheMonthAllowed?: IProductDetailsProps["isSkipBookOfTheMonthAllowed"];
}

export const initialState: IBookOfTheMonthState = {
    isSkipBookOfTheMonthPending: false,
    bookOfTheMonthStatusLabel: undefined,
    isSkipBookOfTheMonthAllowed: undefined
};

const BookOfTheMonthReducer = (state: IBookOfTheMonthState = initialState, action: BookOfTheMonthAction) => {
    switch (action.type) {
        case getType(bookOfTheMonthActions.skipBookOfTheMonthRequest):
            return update(state, {
                isSkipBookOfTheMonthPending: { $set: true }
            });
        case getType(bookOfTheMonthActions.skipBookOfTheMonthSuccess):
            return update(state, {
                isSkipBookOfTheMonthPending: { $set: false },
                bookOfTheMonthStatusLabel: { $set: action.payload.bookOfTheMonthStatusLabel },
                isSkipBookOfTheMonthAllowed: { $set: action.payload.isSkipBookOfTheMonthAllowed }
            });
        case getType(bookOfTheMonthActions.skipBookOfTheMonthError):
            return update(state, {
                isSkipBookOfTheMonthPending: { $set: false }
            });
        default:
            return state;
    }
};

export default BookOfTheMonthReducer;
